import { FC } from 'react';
// components
import AddExcipientComponent from 'components/main/Excipient/Add';

const AddExcipient: FC = () => <AddExcipientComponent />;

export default AddExcipient;
